import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/ticket-lifecycle/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      path: PAGE_PATHS.TICKET_LIFECYCLE,
      app: APP_PATHS.VULNERABILITIES,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
